import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, Tour } from "../../../Constant";
import UserProfileFifthStyle from "./UserProfileFifthStyle";
import UserProfileFirstStyle from "./UserProfileFirstStyle";
import UserProfileFourthStyle from "./UserProfileFourthStyle";
import UserProfileSecondStyle from "./UserProfileSecondStyle";
import UserProfileThirdStyle from "./UserProfileThirdStyle";

const TourMain = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Tour} parent={BonusUi} title={Tour} />
      <Container fluid>
        <div className="user-profile">
          <Row>
            <UserProfileFirstStyle />
            <UserProfileSecondStyle />
            <UserProfileThirdStyle />
            <UserProfileFourthStyle />
            <UserProfileFifthStyle />
          </Row>
        </div>
      </Container>
    </>
  );
};

export default TourMain;
